import { InputSliderCombo } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { maxLoanAmount, minLoanAmount } from '../../minMaxLoanAmounts';
import { CalculatorProps } from './CalculatorTermSelection';
import { disablePreview } from '../../OfferConfig';
import { useSetAtom } from 'jotai';

export const CalculatorInputSlider = ({
  tlOffers
}: CalculatorProps) => {
  const setDisabled = useSetAtom(disablePreview)
  return <Stack gap={1}>
    <div className="fw-bold">
      <FormattedMessage id="calculator.termAmt" />
    </div>
    <Controller
      name="offer.loanAmount"
      render={({ field: { onChange, value } }) => (
        <InputSliderCombo
          min={minLoanAmount(tlOffers)}
          max={maxLoanAmount(tlOffers)}
          initialValue={value}
          onChange={c=> (setDisabled(true), onChange(c))}
          onInput={c=> (setDisabled(true))}
        />
      )}
    />
  </Stack>
}